export default __webpack_public_path__ + "v1.18.25/static/media/info-icon.c45feb7c.svg";